module.exports = __webpack_public_path__ + "static/logo_HeroCs_d2_mobile-205178c1987a38c3c2c45ff04088ae4d.png";